export const ROUTES = {
  DATOS_PERSONALES: "/datosPersonales",
  SIMULADOR: "/simulador",
};
